/**
 * Address Service
 * Handles address management operations
 */

import apiService from '../../../services/apiService';

const addressService = {
  // Get all addresses for current user
  async getAddresses() {
    try {
      const response = await apiService.get('/shop/addresses');
      return response || [];
    } catch (error) {
      console.error('Error fetching addresses:', error);
      throw error;
    }
  },

  // Get single address by ID
  async getAddress(addressId) {
    try {
      const response = await apiService.get(`/shop/addresses/${addressId}`);
      return response;
    } catch (error) {
      console.error('Error fetching address:', error);
      throw error;
    }
  },

  // Create new address
  async createAddress(addressData) {
    try {
      const response = await apiService.post('/shop/addresses', addressData);
      return response;
    } catch (error) {
      console.error('Error creating address:', error);
      throw error;
    }
  },

  // Update existing address
  async updateAddress(addressId, addressData) {
    try {
      const response = await apiService.put(`/shop/addresses/${addressId}`, addressData);
      return response;
    } catch (error) {
      console.error('Error updating address:', error);
      throw error;
    }
  },

  // Delete address
  async deleteAddress(addressId) {
    try {
      await apiService.delete(`/shop/addresses/${addressId}`);
      return true;
    } catch (error) {
      console.error('Error deleting address:', error);
      throw error;
    }
  },

  // Set default address
  async setDefaultAddress(addressId) {
    try {
      const response = await apiService.put(`/shop/addresses/${addressId}/default`);
      return response;
    } catch (error) {
      console.error('Error setting default address:', error);
      throw error;
    }
  }
};

export default addressService;

